import axios from 'axios';
export const getTeams = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`team`);
};
export const getById = (Id: number) => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL+`team/` + Id);
};

export const createTeam = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.post(process.env.REACT_APP_API_GLOBAL_URL+`team/add`, obj, { headers });
};

export const teamUpdate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`team/update`, obj, {
    headers,
  });
};
export const teamDelete = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL+`team/delete`, obj);
};
export const getTeamAssigments = (Id: number) => {
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`assignment/team-assignment?where=` + Id
  );
};
